import type { FC } from 'react';
import Dorsia from '../../../assets/images/Dorsia.svg?react';
import styles from './EventPage.module.css';

interface EventHeaderProps {
  step: number;
  totalSteps?: number;
}

/**
 * EventHeader renders the top navigation bar for the event booking widget.
 *
 * Layout: DORSIA logo (left) | Step indicator (center, absolute)
 *
 * When `step` is 0, the step indicator is hidden.
 */
const EventHeader: FC<EventHeaderProps> = ({ step, totalSteps = 5 }) => {
  return (
    <header className={styles.eventHeader}>
      <Dorsia className={styles.eventHeaderLogo} role="img" aria-label="Dorsia" />

      {step > 0 && (
        <span className={styles.eventHeaderStep}>
          Step {step} of {totalSteps}
        </span>
      )}

      <div />
    </header>
  );
};

export default EventHeader;
